import React from "react";
import "./summary.css";

export default function SummaryScreen({ history, onExit }) {
  const totalQuestions = history.length;
  const correctAnswers = history.filter((h) => h.correct === h.user).length;
  const percentage = totalQuestions > 0 ? Math.round((correctAnswers / totalQuestions) * 100) : 0;

  return (
    <div className="summary-screen">
      
      {/* HEADER */}
      <div className="summary-header">
        <h1>Results</h1>
      </div>

      {/* PERCENTAGE CIRCLE */}
      <div className="percentage-wrapper">
        <div className={`percentage-circle ${percentage >= 50 ? "success" : "danger"}`}>
          {percentage}%
        </div>
      </div>

      {/* HISTORY LIST */}
      <div className="history-list">
        {history.map((item, index) => {
          const isCorrect = item.correct === item.user;
          return (
            <div className="exercise history-item" key={index}>
              <div className="config-card result-card">
                <div className="config-title">Question {index + 1}</div>
                
                {/* Status Badge */}
                <div className={`status-badge ${isCorrect ? "success" : "danger"}`}>
                  {isCorrect ? "✔" : "✖"}
                </div>

                <div className="row">
                  <span className="expression-text">{item.expression} =</span>
                  <span className="result-val">{item.correct}</span>
                </div>

                <div className="row highlight">
                  <span>Your Answer</span>
                  <span className="result-val">{item.user}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* EXIT BUTTON */}
      <div className="summary-footer">
        <button className="btn-primary" onClick={onExit}>
          Exit
        </button>
      </div>

    </div>
  );
}
